import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import Modal from 'react-modal';
import ModalB from 'components/Modal/ModalB';
import { timeLabel } from 'utils/Seminar';
import classes from './SeminarDetailsModal.module.scss';

const SeminarDetailsModal = (props) => {
  const {
    displayName,
    timeZone,
    isOpen,
    sessions = [],
    closeModal,
  } = props;
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      shouldCloseOnOverlayClick
      ariaHideApp={false}
      className={classes.modal}
      overlayClassName={classes.overlayModal}
      closeTimeoutMS={250}
    >
      <ModalB hideModal={closeModal}>
        <div className={classes.seminarDatesWrapper}>
          <h3
            className={classes.seminarDatesHeading}
            dangerouslySetInnerHTML={{ __html: displayName }}
          />
          <div className={classes.seminarDatesListContainer}>
            {sessions.map((o, index) => (
              <div key={index} className={classes.seminarDateListItem}>
                <div className={classes.seminarDateListItemHeader}>
                  {moment.tz(o.start, timeZone).format('dddd, MMMM Do YYYY')},
                </div>
                {(o.start || o.end) &&
                <div className={classes.seminarDateListItemBody}>
                  {timeLabel(o.start, o.end, timeZone)}
                </div>}
              </div>
            ))}
          </div>
        </div>
      </ModalB>
    </Modal>
  );
};

SeminarDetailsModal.propTypes = {
  displayName: PropTypes.string,
  timeZone: PropTypes.string,
  sessions: PropTypes.array,
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
};

export default SeminarDetailsModal;
